import { CookieStorage } from 'amazon-cognito-identity-js';

// Cognito/Amplify configuration file
// Values are read from environment variables so you can configure them at build/deploy time (e.g. DigitalOcean).
// Required env vars (prefixed with REACT_APP_):
// - REACT_APP_COGNITO_REGION
// - REACT_APP_COGNITO_USER_POOL_ID
// - REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID
// - REACT_APP_COGNITO_OAUTH_DOMAIN (host only, e.g. 'your-prefix.auth.us-east-2.amazoncognito.com')
// Optional at build time:
// - REACT_APP_COGNITO_REDIRECT_SIGNIN
// - REACT_APP_COGNITO_REDIRECT_SIGNOUT

const rawDomain = process.env.REACT_APP_COGNITO_OAUTH_DOMAIN || '';
// Normalize domain: strip protocol and trailing slash if accidentally provided
const domain = rawDomain.replace(/^https?:\/\//, '').replace(/\/$/, '');

const isProduction = process.env.NODE_ENV === 'production';
const hostname = typeof window !== 'undefined' && window.location ? window.location.hostname : 'localhost';

const cognitoConfig = {
  Auth: {
    // Amazon Cognito Region (REACT_APP_COGNITO_REGION)
    region: process.env.REACT_APP_COGNITO_REGION || '',

    // Amazon Cognito User Pool ID (REACT_APP_COGNITO_USER_POOL_ID)
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',

    // Amazon Cognito Web Client ID (App client ID) (REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID)
    userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID || '',

    // Secure Cookie Storage for token persistence (eliminates insecure localStorage token storage)
    storage: new CookieStorage({
      domain: hostname,
      secure: isProduction,
      sameSite: 'strict',
      path: '/',
      expires: 30
    }),

    // Hosted UI configuration (for Cognito Managed Login using PKCE)
    oauth: {
      domain: domain || '',
      scope: ['openid', 'email', 'profile'],
      // Allow overriding redirect URLs via env; default to dashboard / root
      redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN || (typeof window !== 'undefined' && window.location ? window.location.origin + '/dashboard' : '/dashboard'),
      redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT || (typeof window !== 'undefined' && window.location ? window.location.origin + '/' : '/'),
      responseType: 'code'
    }
  }
};

// Warn at runtime if config looks incomplete (development only)
if (!cognitoConfig.Auth.region || !cognitoConfig.Auth.userPoolId || !cognitoConfig.Auth.userPoolWebClientId || !cognitoConfig.Auth.oauth.domain) {
  if (process.env.NODE_ENV === 'development') {
    console.warn('Cognito configuration incomplete. Set REACT_APP_COGNITO_* environment variables at build time or fill in src/config/cognitoConfig.js. Also ensure redirect URLs are whitelisted in the Cognito App Client settings.');
  }
}

export default cognitoConfig;
